window.AttendanceAPI = new (function () {

    var self = this,
        _protected = BaseAPI.call(self);

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.TSAttendanceBaseUrl : publicConfiguration.AttendanceBaseUrl);

    self.getAbsenceSettingsHolidayPlans = function (brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getDefaultHolidayPlans = function (brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/rules', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.addDefaultHolidayPlan = function (brandId, planId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId + '/rules', 'POST', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateDefaultHolidayPlan = function (brandId, planId, defaultPlanId, payload) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId + '/rules/' + defaultPlanId, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.deleteDefaultHolidayPlan = function (brandId, planId, defaultPlanId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId + '/rules/'+ defaultPlanId +'/archive', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.recoverDefaultHolidayPlan = function (brandId, planId, defaultPlanId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId + '/rules/'+ defaultPlanId +'/unarchive', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.addNewHolidayPlan = function (data, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans', 'POST', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.loadPlanData = function (brandId, planId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    const [getBusinessAttendanceSettings, resetBusinessAttendanceSettings] = cacheService.cache(function (brandId) {

        var deferred = $q.defer();

        _protected.request( 'business/brands/' + brandId +'/settings', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data.settings || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    });
    self.getBusinessAttendanceSettings = getBusinessAttendanceSettings;

    self.getBusinessBrandsDays = function (brandId, holidaysType) {
        var deferred = $q.defer();

        _protected.request('business/brands/' + brandId +'/days/settings', 'GET', {types: holidaysType})
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data.day_settings || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBusinessBrandsDays = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('business/brands/' + brandId +'/days/settings', 'PUT', payload)
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data.day_settings || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBusinessTimeOffSettings = function (brandId, type ,payload) {
        var deferred = $q.defer();

        _protected.request('business/'+'brands/' + brandId +'/absences/types/'+ type +'/settings', 'PUT', payload)
            .then(function (res) {
                if (res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.saveDefaultPlan = function (brandId, planId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId, 'PUT', {
            status: 'DEFAULT'
        }).then(function (response) {
            if (response.data && response.data.data && response.status === 200) {
                defer.resolve(response.data.data);
            } else {
                defer.reject(response);
            }
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.updatePlan = function (data, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + data.id, 'PUT', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.deleteHolidayPlan = function (planId, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_plans/' + planId, 'DELETE')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getSicknessSettings = function (brandId) {

        var defer = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/absences/settings?types=SICKNESS', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateSicknessSettings = function (data, absenceId, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/' + absenceId + '/settings', 'PUT', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                console.log(error);
            });

        return defer.promise;
    };

    self.getAbsenceCustomSettings = function (brandId, typesParams) {
        var defer = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/absences/settings', 'GET', {types: typesParams})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {

                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateAbsenceCustomSettings = function (data, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/settings', 'PUT', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getDaysSettings = function (brandId, types) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/days/settings?types=' + types, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status) {
                    defer.resolve(response.data.data.day_settings || []);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateDaysSettings = function (data, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/days/settings', 'PUT', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data.day_settings);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.removeEmployeeAbsenceRequest = function (brandId, absenceId) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for removeEmployeeAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for removeEmployeeAbsenceRequest api';
        }

        _protected
            .request('employees/brands/' + brandId + '/absences/requests/' + absenceId, 'DELETE')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.removeEmployerAbsenceRequest = function (brandId, absenceId) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for removeEmployerAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for removeEmployerAbsenceRequest api';
        }

        _protected
            .request('brands/' + brandId + '/absences/requests/' + absenceId, 'DELETE')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.rejectEmployerAbsenceRequest = function (brandId, absenceId, userId, reason) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for rejectEmployerAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for rejectEmployerAbsenceRequest api';
        }
        var url;
        var params = {};

        if (reason) {
            url = self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/absences/requests/' + absenceId + '/reject';
            params['rejection_reason'] = reason;
        } else {
            url = 'brands/' + brandId + '/absences/requests/' + absenceId + '/reject';
        }

        _protected.request(url, 'POST', params).then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsenceRequestHistory = function (brandId, requestId) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for approveEmployerAbsenceRequest api';
        }

        if (!requestId) {
            throw 'absenceId is required for approveEmployerAbsenceRequest api';
        }
        _protected
            .request('brands/' + brandId + '/absences/requests/' + requestId + '/audits', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.approveEmployerAbsenceRequest = function (brandId, absenceId, days) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for approveEmployerAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for approveEmployerAbsenceRequest api';
        }

        _protected
            .request('brands/' + brandId + '/absences/requests/' + absenceId + '/approve', 'POST', days)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.withdrawAbsenceRequest = function (brandId, absenceId) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for withdrawAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for withdrawAbsenceRequest api';
        }

        _protected
            .request('employees/brands/' + brandId + '/absences/requests/' + absenceId + '/withdraw', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.closeAbsenceRequest = function (brandId, absenceId) {
        var defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required for closeAbsenceRequest api';
        }

        if (!absenceId) {
            throw 'absenceId is required for closeAbsenceRequest api';
        }

        _protected
            .request('employees/brands/' + brandId + '/absences/requests/' + absenceId + '/close', 'POST')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getEmployeeAbsence = function (brandId, types, statuses, sortBy, offset, limit) {
        var defer = $q.defer();

        self.getEmployerAbsenceView(
            brandId,
            types,
            statuses,
            null,
            null,
            null,
            null,
            null,
            null,
            sortBy,
            offset,
            limit,
            false
        ).then(function (requests) {
            defer.resolve(requests);
        }, function (error) {
            defer.reject(error);
        });

        return defer.promise;
    };

    self.markAbsenceAsSeen = function (brandId, absenceRequestIds) {

        var deferred = $q.defer();

        var params = {
            absence_request_ids: absenceRequestIds
        };

        _protected.request("employees/brands/" + brandId + "/absences/activities/mark_seen", "POST", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getEmployerAbsenceView = function (brandId, types, statuses, categories, positions, userIds, absenceIds, startDate, endDate, sortBy, offset, limit, isEmployer) {

        if (!brandId) {
            throw 'Brand id is required for getEmployerAbsenceView api';
        }

        var defer = $q.defer();

        var payload = {};

        if (types && Array.isArray(types)) {
            payload['types'] = types;
        }

        if (statuses && Array.isArray(statuses)) {
            payload['statuses'] = statuses;
        }

        if (categories && Array.isArray(categories)) {
            payload['categories'] = categories;
        }

        if (positions && Array.isArray(positions)) {
            payload['positions'] = positions;
        }

        if (userIds && Array.isArray(userIds)) {
            payload['user_ids'] = userIds;
        }

        if (absenceIds && Array.isArray(absenceIds)) {
            payload['absence_ids'] = absenceIds;
        }

        if (startDate && Date.parse(startDate)) {
            payload['start_date'] = moment(startDate).format("YYYY-MM-DD");
        }

        if (endDate && Date.parse(endDate)) {
            payload['end_date'] = moment(endDate).format("YYYY-MM-DD");
        }

        if (sortBy) {
            payload['sort_by'] = sortBy;
        }

        if (parseInt(offset) >= 0) {
            payload['offset'] = parseInt(offset);
        }

        if (parseInt(limit) >= 0) {
            payload['limit'] = parseInt(limit);
        }

        var url = 'employees/brands/' + brandId + '/absences/requests';

        if (isEmployer) {
            url = 'brands/' + brandId + '/absences/requests';
        }

        _protected.request(url, 'GET', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsencesStats = function (brandId, types, statuses, categories, positions, startDate, endDate) {

        if (!brandId) {
            throw 'Brand id is required for getAbsencesStats api';
        }

        var defer = $q.defer();

        var payload = {};

        if (types && Array.isArray(types)) {
            payload['types'] = types;
        }

        if (statuses && Array.isArray(statuses)) {
            payload['statuses'] = statuses;
        }

        if (categories && Array.isArray(categories)) {
            payload['categories'] = categories;
        }

        if (positions && Array.isArray(positions)) {
            payload['positions'] = positions;
        }

        if (startDate && Date.parse(startDate)) {
            payload['start_date'] = moment(startDate).format("YYYY-MM-DD");
        }

        if (endDate && Date.parse(endDate)) {
            payload['end_date'] = moment(endDate).format("YYYY-MM-DD");
        }

        var url = 'brands/' + brandId + '/absences/requests/stats';

        _protected.request(url, 'GET', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsenceReasons = function (brandId, user, types) {

        var defer = $q.defer();

        types = types || ['CUSTOM', 'HOLIDAY'];

        var url = 'employees/brands/' + brandId + '/absences';

        if (user.isEmployer) {
            url = 'brands/' + brandId + '/absences';
        }

        _protected.request(url, 'GET', {types: types, measured_by: "DAYS,HOURS"})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsenceTypes = cacheService.cache(function (brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/types', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    var reasons = [];
                    response.data.data.brand_absences_types.forEach(function (type) {
                        var isExist = reasons.find(function (item) {
                            return item.title === type.title
                        })
                        if(!isExist){
                            reasons.push(type)
                        }
                    });
                    defer.resolve(reasons);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    })[0];

    self.getEmployees = function (brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/users', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.createAbsenceRequest = function (data, brandId, user) {

        var defer = $q.defer();

        var url = 'employees/brands/' + brandId + '/absences/requests';

        if (user.isEmployer) {
            url = 'brands/' + brandId + '/users/' + data.employee.id + '/absences/requests';
        }

        delete data.isAllDay;
        delete data.employee;

        if (data.fromTime) {
            delete data.fromTime;
            delete data.toTime;
        }

        _protected.request(url, 'POST', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.createSicknessRequest = function (data, brandId, user) {

        var defer = $q.defer();

        var url = 'employees/brands/' + brandId + '/absences/requests';

        if (user.isEmployer) {
            url = 'brands/' + brandId + '/users/' + data.employee.id + '/absences/requests';
        }

        delete data.employee;

        _protected.request(url, 'POST', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };


    self.getUploadAttachmentsUrl = function (userId, fileName, brandId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/signed_url?type=ABSENCE&name=' + fileName, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getEmployeeRequestDetails = function (brandId, requestId) {

        var defer = $q.defer();

        _protected.request('employees/brands/' + brandId + '/absences/requests/' + requestId, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function () {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getRequestDetails = function (brandId, requestId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/requests/' + requestId, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.closeSicknessRequest = function (data, brandId, requestId) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/requests/' + requestId + '/close', 'POST', data)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.loadHolidayPlanStats = function (brandId, userId, user) {

        var defer = $q.defer();

        var url = 'brands/' + brandId + '/users/' + userId +'/holiday_plans/stats';

        if (user && !user.isEmployer) {
            url = 'employees/brands/' + brandId + '/absences/holiday_plans/stats';
        }

        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAbsenceDaysSettings = function (brandId, user, types) {

        var defer = $q.defer();

        var url = 'brands/' + brandId + '/absences/days/settings';

        if (user && !user.isEmployer) {
            url = 'employees/brands/' + brandId + '/absences/days/settings';
        }

        var payload = {
            types: types || ['HOLIDAY']
        };

        _protected.request(url, 'GET', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUserEffectiveHolidayPlan = function (brandId) {

        var defer = $q.defer();

        _protected.request('employees/brands/' + brandId + '/users/holiday_plans', 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getUserHolidayPlans = function (brandId, userId, status) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {};
        if (status) {
            params['status'] = status;
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserHolidayPlansStats = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/stats', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.assignUserNewHolidayPlan = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var holidayPlansId = payload.id;

        payload = {
            start_date: payload.start_date
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/' + holidayPlansId + '/assign', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSicknessOtherAbsencesInfo = function (brand, userId) {
        var deferred = $q.defer();

        if (!brand.id) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var params = {types: []};
        var types = ['SICKNESS', 'CUSTOM', "PATERNITY", "BEREAVEMENT", "MATERNITY", "SHARED_PARENTAL", "ADOPTION"];
        var brandAbsences = _.pluck(brand['brand_absences'], 'type') || [];

        for (var i in types) {
            if (brandAbsences && brandAbsences.indexOf(types[i]) > -1) {
                params["types"].push(types[i]);
            }
        }

        _protected.request('brands/' + brand.id + '/users/' + userId + '/absences/stats', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getHolidayPlanHistory = function (brandId, userId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/history', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteUserHolidayPlan = function (brandId, userId, holidayPlanId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/' + holidayPlanId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAdjustmentsHistory = function (brandId, userId, holidayPlanId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/' + holidayPlanId + '/adjustments/history', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.postAdjustmentsHolidayPlan = function (brandId, userId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var holidayPlansId = payload.id;

        payload = {
            adjustment_value: payload.adjustment_value,
            reason: payload.reason
        };

        _protected.request('brands/' + brandId + '/users/' + userId + '/holiday_plans/' + holidayPlansId + '/adjustments', 'POST', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status == 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getHolidayYear = function (brandId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/holiday_year', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getColleagues = function (brandId, positionCode, startDate, endDate) {

        var deferred = $q.defer();

        var payload = {
            position_codes: positionCode,
            start_time: Utils.getISODate(moment(startDate)),
            end_time: Utils.getISODate(moment(endDate))
        };

        _protected.request('employees/brands/' + brandId + '/available_colleagues', 'GET', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.loadAbsenceTimeOffSettings = function (brandId, type) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/types/' + type + '/settings', 'GET')
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    self.saveAbsenceTimeOffSettings = function (brandId, type, payload) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/types/' + type + '/settings', 'PUT', payload)
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateRequestDetails = function (brandId, requestId, payload) {

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/absences/requests/' + requestId, 'PUT', payload)
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.editEmployeeAbsenceRequest = function (brandId, absenceId, startDate, endDate) {
        var defer = $q.defer();

        var payload = {
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD")
        };

        _protected
            .request('employees/brands/' + brandId + '/absences/requests/' + absenceId, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.loadEmployeeListOfReasons = function (brandId, types) {

        var defer = $q.defer();

        var queryParams = '';

        for (var i in types) {

            if (i > 0) {
                queryParams += '&types=' + types[i];
            } else {
                queryParams += '?types=' + types[i];
            }
        }

        _protected.request('employees/brands/' + brandId + '/absences' + queryParams, 'GET')
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.checkRequestErrors = function (brandId, userId, user, payLoad) {

        var defer = $q.defer();

        var url = self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/users/' + userId + '/absences/requests/check';

        if (!user.isEmployer) {
            url = self.apiUrl.replace('v1', 'v2') + 'employees/brands/' + brandId + '/absences/requests/check';
        }

        _protected
            .uniqueRequest(url, 'POST', payLoad)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBrandAvailabilitySettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/availabilities/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandAvailabilitySettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/availabilities/settings', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBusinessBrandAvailabilitySettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('business/brands/' + brandId + '/availabilities/settings', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAbsenceReasons = function (brandId, type, status) {

        var defer = $q.defer();

        var params = {};

        if (status) {
            params.status = status;
        }

        _protected.request('business/brands/' + brandId + '/absences/' + type + '/reasons', 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateBrandAbsenceReasons = function (brandId, type, payload) {
        var deferred = $q.defer();

        _protected.request('business/brands/' + brandId + '/absences/' + type + '/reasons', 'PUT', payload)
            .then(function (res) {
                    if (res.data && res.data.data) {
                        deferred.resolve(res.data.data.reasons || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandRequestLimits = function (brandId, absenceType) {
        let deferred = $q.defer();
        let params = {
            absence_types: absenceType
        }

        _protected.request(`brands/${brandId}/absences/requests_limits`, 'GET', params)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data.brand_absence_requests_limits || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBrandRequestLimit = function (brandId, requestLimitId, payload) {
        let deferred = $q.defer();

        _protected.request(`brands/${brandId}/absences/requests_limits/${requestLimitId}`, 'PUT', payload)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteBrandRequestLimit = function (brandId, requestLimitId) {
        let deferred = $q.defer();

        _protected.request(`brands/${brandId}/absences/requests_limits/${requestLimitId}`, 'DELETE')
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.addBrandRequestLimit = function (brandId, payload) {
        let deferred = $q.defer();

        _protected.request(`brands/${brandId}/absences/requests_limits`, 'POST', payload)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    self.getBusinessRequestLimits = function (brandId, absenceType) {
        let deferred = $q.defer();
        let params = {
            absence_types: absenceType
        }

        _protected.request(`business/brands/${brandId}/absences/requests_limits`, 'GET', params)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data.brand_absence_requests_limits || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateBusinessRequestLimit = function (brandId, requestLimitId, payload) {
        let deferred = $q.defer();

        _protected.request(`business/brands/${brandId}/absences/requests_limits/${requestLimitId}`, 'PUT', payload)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.deleteBusinessRequestLimit = function (brandId, requestLimitId) {
        let deferred = $q.defer();

        _protected.request(`business/brands/${brandId}/absences/requests_limits/${requestLimitId}`, 'DELETE')
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.addBusinessRequestLimit = function (brandId, payload) {
        let deferred = $q.defer();

        _protected.request(`business/brands/${brandId}/absences/requests_limits`, 'POST', payload)
            .then(function (res) {
                    if (res?.data?.data) {
                        deferred.resolve(res.data.data || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

});
